import React, {Suspense, useEffect} from "react";
import {Redirect, Switch, useLocation} from "react-router-dom";
import {useDispatch} from "react-redux";
import {LayoutSplashScreen, ContentRoute} from "../_metronic/layout";
import TicketsPage from "./pages/TicketsPage";
import VoidTicketsPage from "./pages/VoidTicketsPage";
import AgentTransactionsPage from "./pages/AgentTransactionsPage";
import TicketsTransactionsPage from "./pages/TicketsTransactionsPage";
import CirculationsPage from './pages/CirculationsPage';
import PlayPage from "./pages/PlayPage";
import WeeklyReportPage from "./pages/WeeklyReportPage";
import DailyReportPage from "./pages/DailyReportPage";
import useAuth from "../app/hooks/useAuth";
import * as auth from "./modules/Auth/_redux/authRedux"

const {getProfile} = auth.actions;

export default function BasePage() {
    const dispatch = useDispatch();
    const {isSuperAgent} = useAuth();
    const location = useLocation();

    useEffect(() => {
        dispatch(getProfile())
    }, [location])
    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    /* Redirect from root URL to /dashboard. */
                    <Redirect exact from="/" to="/transactions/ticket"/>
                }

                <ContentRoute path="/transactions/ticket" component={TicketsTransactionsPage}/>
                <ContentRoute path="/transactions/agent" component={AgentTransactionsPage}/>
                <ContentRoute path="/tickets" component={TicketsPage}/>
                <ContentRoute path="/circulations" component={CirculationsPage}/>
                {!isSuperAgent && (
                    <>
                        <ContentRoute path="/play" component={PlayPage}/>
                        <ContentRoute path="/voidTickets" component={VoidTicketsPage}/>
                        <ContentRoute path="/reports/weekly-report" component={WeeklyReportPage}/>
                        <ContentRoute path="/reports/daily-report" component={DailyReportPage}/>
                    </>
                )}
                <Redirect to="error/error-v5"/>
            </Switch>
        </Suspense>
    );
}
